function initStickyBar() {
  var collection_page = $('.boost-sd__filter-product-list');
  if (collection_page.length) {
    $(window).on('scroll', function () {
      var $filterWrapper = $('#boost-sd__filter-tree-wrapper');
      if (window.innerWidth < 769) {
        var $filterWrapper = $('.boost-sd__toolbar.boost-sd__toolbar--2_1');
      }
      var lastScrollTop = $filterWrapper.offset().top;
      var originalOffsetTop = $filterWrapper.offset().top;
      var originalHeight = $filterWrapper.outerHeight();
      var headerHeight = $('#header-component .header__row').outerHeight();
      $filterWrapper.css('--height', originalHeight + 'px').css('--header', headerHeight + 'px');
      var scrollTop = $(this).scrollTop();
      // Always add class when top bar has scrolled up past original position  
      if (scrollTop > originalOffsetTop) {
        if (!$filterWrapper.hasClass('mrk-fixed-collection-filters')) {
          $filterWrapper.addClass('mrk-fixed-collection-filters');
        }
      } else {
        $filterWrapper.removeClass('mrk-fixed-collection-filters');
        $filterWrapper.css('min-height', '');
      }

      // If user scrolls up while fixed, set min-height
      if (scrollTop < lastScrollTop && scrollTop > originalOffsetTop) {
        $filterWrapper.css('min-height', originalHeight + 'px');
      }

      lastScrollTop = scrollTop;
    });
  }
}
function afterRender() {
  $('.mrk-collection-item-frames-wrapper').each(function () {
    if ($(this).find('.mrk-frame-image-item').length) {
      return;
    }
    var width = Number($(this).attr('width')),
      height = Number($(this).attr('height')),
      ratio = Number($(this).attr('ratio')),
      hasFrames = $(this).attr('hasframe') == 'true' ? true : false;
    const aspectRatio = height / width || 1;
    const frames = getFrames(ratio, hasFrames, window.FrameType);
    console.log(frames, hasFrames, ratio, 'asd');
    const leftRight = Number($(frames).find('.mrk-frame-image-item:eq(0)').attr('left_right')) / 2;
    const topBottom = Number($(frames).find('.mrk-frame-image-item:eq(0)').attr('top_bottom')) / 2;
    $(this).css({
      '--tb': `calc(${topBottom}% - 2px)`,
      '--lr': `calc(${leftRight}% - 2px)`
    });
    $(this).find('.mrk-frames-wrapper').html(frames);
  });
  addFrameFilters();
}
function addFrameFilters() {
  const container = $('body');
  const filterListElement = $(container).find('.boost-sd__filter-tree-horizontal-option-list');
  if (window.innerWidth > 769) {
    if (filterListElement.length && $(container).find('.mrk-collection-filter-frame-wrapper').length == 0) {
      filterListElement.append($('#filter-frames-items').html());
    }
  } else {
    const filterListElementMobile = $(container).find('.mrk-count-frames-wrapper');
    if (filterListElementMobile.length && $(container).find('.mrk-collection-filter-frame-wrapper').length == 0) {
      filterListElementMobile.prepend($('#filter-frames-items').html());
    }
  }
  setTimeout(function () {
    $('[name="mrk-collection-frame"]:checked').trigger('change');
    var count = $('.boost-sd__filter-option-item-button--selected').length;
    if (count > 0)
      $('#boost-sd__filter-tree-toggle-button').attr('data-count', count);
    else
      $('#boost-sd__filter-tree-toggle-button').removeAttr('data-count');
  }, 200);
}
boostWidgetIntegration.regisCustomization(afterRender, 'filter');
// Function to get frames based on aspect ratio and product type
function getFrames(aspectRatio, hasFrames, type) {
  // Generate frames using the frame data HTML from a template
  const allFrames = $(`<div>${$('#mrk-frames-data').html()}</div>`);
  const tolerance = 0.01;
  const lowerBound = aspectRatio - tolerance;
  const upperBound = aspectRatio + tolerance;

  // Filter frames based on aspect ratio tolerance and type
  $(allFrames).find('.mrk-frame-image-item').each(function() {
    const frameRatio = Number($(this).attr('ratio'));
    const frameType = $(this).attr('type');
    if (!(frameRatio > lowerBound && frameRatio < upperBound && type == frameType)) {
      $(this).remove();
    }
  });

  // Return the filtered frames HTML if frames exist, else return empty string
  return hasFrames ? $(allFrames).html() : '';
}

$(function () {
  initStickyBar()
})